import { Injectable } from '@angular/core';
import { BehaviorSubject, fromEvent } from 'rxjs';
import { pluck, distinctUntilChanged, auditTime, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ScreenService {
  screenWidth$ = new BehaviorSubject(window.innerWidth);

  isSmallWidth$ = this.screenWidth$.pipe(
    map((screenWidth) => screenWidth < 1190),
    distinctUntilChanged()
  );

  constructor() {
    this.setScreenWidthChange();
  }

  private setScreenWidthChange(): void {
    fromEvent(window, 'resize')
      .pipe(
        pluck('target', 'innerWidth'),
        distinctUntilChanged(),
        auditTime(100),
        map((screenWidth) => Number(screenWidth))
      )
      .subscribe((screenWidth) => {
        this.screenWidth$.next(screenWidth);
      });
  }
}
